var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83333 9.16669V5.83335C4.83333 4.72829 5.27232 3.66848 6.05372 2.88708C6.83512 2.10567 7.89493 1.66669 9 1.66669C10.1051 1.66669 11.1649 2.10567 11.9463 2.88708C12.7277 3.66848 13.1667 4.72829 13.1667 5.83335V9.16669M3.16667 9.16669H14.8333C15.7538 9.16669 16.5 9.91288 16.5 10.8334V16.6667C16.5 17.5872 15.7538 18.3334 14.8333 18.3334H3.16667C2.24619 18.3334 1.5 17.5872 1.5 16.6667V10.8334C1.5 9.91288 2.24619 9.16669 3.16667 9.16669Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/IconPassword.9f81bd6bb6dc413f4d60671b74b38736.svg";
export { ForwardRef as ReactComponent };